import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-courses',
  templateUrl: './hometwo-courses.component.html',
  styleUrls: ['./hometwo-courses.component.scss']
})
export class HometwoCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
